import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { Name, Status, Date } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getDynamicForm2 as onGetDynamicForm2,
  addDynamicForm2 as onaddDynamicForm2,
  updateDynamicForm2 as onUpdateDynamicForm2,
  deleteDynamicForm2 as onDeleteDynamicForm2,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import moment from "moment";

//redux
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

const ContactsList = props => {

  //meta title
  document.title = "Anketler | Dr Randevu ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [getEdit, setEdit] = useState();

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (getEdit && getEdit.Diagnostic_Form_Title) || "",

    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen Soruyu Giriniz"),

    }),
    onSubmit: values => {
      var localDate = moment().local();

      				
      if (isEdit) {
        const updateUser = {
          ID: getEdit.ID,
          Diagnostic_Form_Title:values.title,
       
                };
                console.log("updateUser",updateUser)
        // update user
        dispatch(onUpdateDynamicForm2(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Diagnostic_Form_Title:values["title"],
        
        };
        // save new user
        dispatch(onaddDynamicForm2(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.dynamic2,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getEditForm, setEditForm] = useState(false);


  const [modalOption, setModalOption] = useState(false);
  const [inputData, setInputData] = useState({ option: "", score: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
      {
        Header: "Soru",
        accessor: "Diagnostic_Form_Title",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />;
        },
      },
    

      {
        Header: "Seçenekler",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {  
            cellProps.Diagnostic_Form_Answer != null ? cellProps.Diagnostic_Form_Answer.map((item, index) => {
              return(
              <div key={index}>
            <span >
            {item.Diagnostic_Form_Answer_Title}
          </span>
          </div>)
            })  : null }
          </>
        ),
      },


      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
                <Link
              
               
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserOption(userData);
                }}
              >
              
                Seçenek Ekle
              </Link>

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetDynamicForm2());
      setIsEdit(false);
   }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleOption = () => {
    setModalOption(!modalOption);
  };

  
  const handleUserOption = arg => {
    const user = arg;

    setOptions(user.Diagnostic_Form_Answer)

    setOptionsData(user)
    toggleOption();
  };

  const handleUserClick = arg => {
    const user = arg;
    setEditForm(user)
    setContact(user);
    setIsEdit(true);



    setEdit(user)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteDynamicForm2(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };


  const [options, setOptions] = useState([]); // Seçenekleri tutan dizi
  const [inputValue, setInputValue] = useState(""); // Input alanı değeri
  const [getOptionsData, setOptionsData] = useState(null); // Input alanı değeri




  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Aile Planlaması" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddDynamicForm2={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

<Modal isOpen={modalOption} toggle={toggleOption}>
      <ModalHeader toggle={toggleOption} tag="h4">
        {"Seçenek Ekle"}
      </ModalHeader>
      <ModalBody>
     
        <Row>
       <Col xs={12}>
            <ul>
              {options.map((option, index) => (
                <li key={index}>
                  {option.Diagnostic_Form_Answer_Title} - {option.Diagnostic_Form_Answer_Type} 
                  <Button color="danger" size="sm" onClick={() => removeOption(option.ID)} className="ml-2">
                    Sil
                  </Button>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
        <Button color="success" onClick={toggleOption}>
          Kapat
        </Button>
      </ModalBody>
    </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Aile Planlaması Düzenle" : "Aile Planlaması Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Soru</Label>
                              <Input
                                name="title"
                                type="text"
                                placeholder="Soru"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>
                      
                         
                      
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
